-- Starlight bootstrap code